import { useEffect, useState } from "react"
import Header from "../../../layouts/Header"
import { styled, createTheme, ThemeProvider } from "@mui/material/styles"
import { Box, Grid, TextField, Button, InputLabel } from "@mui/material"
import Swal from "sweetalert2"
import BackIcon from "../../../components/BackIcon"
import CustomFieldset from "../../../components/CustomFieldset"
import CustomHelper from "../../../components/CustomHelper"
import CustomHelperDetail from "../../../components/CustomHelperDetail"
import CustomTooltip from "../../../components/ToolTip"
import CustomDatePicker from "../../../components/CustomDatePicker"
import dayjs from "dayjs"
import CustomTextFieldReadable from "../../../components/CustomTextFieldReadable"
import CustomTextField from "../../../components/CustomTextField"
import CustomTimePicker from "../../../components/CustomTimePicker"
import CustomSelect from "../../../components/CustomSelect"
import CustomAutoComplete from "../../SolicitudDeIngreso/components/CustomAutoComplete"
import fetchwrapper from "../../../services/interceptors/fetchwrapper"
import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query"
import CustomBackdrop from "../../../components/CustomBackdrop"
import BuscarIcon from "../../../assets/iconos/Buscar.ico"
import GrabarIcon from "../../../assets/iconos/Grabar.ico"
import { useNavigate } from "react-router-dom"
import { ConnectingAirportsOutlined, ConstructionOutlined } from "@mui/icons-material"
import { useGridEditing } from "@mui/x-data-grid/internals"

const StyledRoot = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  marginTop: theme.spacing(8),
  flexGrow: 1,
  padding: "0 16px",
  height: "100vh",
}))

const theme = createTheme({
  palette: {
    primary: {
      main: "#196C87",
    },
    secondary: {
      main: "#196C87", // Cambia el color secundario a verde azulado
    },
  },
})
const ClienteBox = styled(Box)({
  gridArea: "ClienteBox",
})
const ContactoBox = styled(Box)({
  gridArea: "ContactoBox",
})
const BodegaBox = styled(Box)({
  gridArea: "BodegaBox",
})
const ArticuloBox = styled(Box)({
  gridArea: "ArticuloBox",
})
const EmbalajeBox = styled(Box)({
  gridArea: "EmbalajeBox",
})
// Contenedor de campos de creacion
const Container = styled(Box)(({ theme }) => ({
  display: "grid",
  gridTemplateColumns: "repeat(12, 1fr)",
  gridTemplateRows: "auto auto auto",
  gridTemplateAreas: `
    "ClienteBox ClienteBox ClienteBox ClienteBox ClienteBox ClienteBox ClienteBox ClienteBox ClienteBox ClienteBox ClienteBox ClienteBox"
    "ContactoBox ContactoBox ContactoBox ContactoBox ContactoBox ContactoBox BodegaBox BodegaBox BodegaBox BodegaBox BodegaBox BodegaBox"
    "ArticuloBox ArticuloBox ArticuloBox ArticuloBox ArticuloBox ArticuloBox ArticuloBox ArticuloBox ArticuloBox ArticuloBox ArticuloBox ArticuloBox "
    "EmbalajeBox EmbalajeBox EmbalajeBox EmbalajeBox EmbalajeBox EmbalajeBox EmbalajeBox EmbalajeBox EmbalajeBox EmbalajeBox EmbalajeBox EmbalajeBox "
  `,
  gap: "8px",
  alignItems: "center",

  [theme.breakpoints.down("sm")]: {
    gridTemplateColumns: "repeat(6, 1fr)",
    gridTemplateAreas: `
      "ClienteBox ClienteBox ClienteBox ClienteBox ClienteBox ClienteBox "
      "ContactoBox ContactoBox ContactoBox ContactoBox ContactoBox ContactoBox"
      "BodegaBox BodegaBox BodegaBox BodegaBox BodegaBox BodegaBox"
      "ArticuloBox ArticuloBox ArticuloBox ArticuloBox ArticuloBox ArticuloBox"
      "EmbalajeBox EmbalajeBox EmbalajeBox EmbalajeBox EmbalajeBox EmbalajeBox"
    `,
  },
}))

const CrearAsociacionProdAgencias = () => {
  const [bodegas, setBodegas] = useState([])
  const [contactos, setContactos] = useState([])
  const [filtros, setFiltros] = useState({
    cliente: {},
    articulo: {},
    embalaje: {},
  })

  const [bodega, setBodega] = useState("")
  const [bodegaDescripcion, setBodegaDescripcion] = useState("")
  const [autoCompleteValueBodega, setAutoCompleteValueBodega] = useState("")
  const [contacto, setContacto] = useState("")
  const [agenciaDescripcion, setAgenciaDescripcion] = useState("")
  const [agencia, setAgencia] = useState("")
  const [autoCompleteValueContacto, setAutoCompleteValueContacto] = useState("")
  const handleSetFiltros = (key, value) => {
    if (filtros[key] !== value) {
      setFiltros((prev) => ({ ...prev, [key]: value }))
    }
  }
  function validateForm() {
    const clienteF = filtros.cliente.clicodigo
    const articuloF = filtros.articulo.artcodigo
    const embalajeF = filtros.embalaje.embcodigo

    // Devuelve un valor booleano directamente
    return clienteF !== "" && articuloF !== "" && embalajeF !== ""
  }

  const {
    data: dataBodegas = [],
    isError: dataBodegasError,
    isFetching: isFetchingBodegas,
    isLoading: isLoadingBodegas,
    refetch: refetchGetAllBodegas,
  } = useGetAllBodegas(filtros.cliente.clicodigo)
  const handleBodegaChange = (selectedValue) => {
    const [codigo, descripcion] = selectedValue.split("-")
    setBodega(codigo)
    setBodegaDescripcion(descripcion)
    setAutoCompleteValueBodega(selectedValue)
  }
  useEffect(() => {
    setBodega(bodega)
    setBodegaDescripcion(bodegaDescripcion)
    console.log("informacion de bodega selected", bodega, bodegaDescripcion)
  }, [bodega])
  function useGetAllBodegas(clicodigo) {
    return useQuery({
      queryKey: ["bodegaAsociacionProductosAgencias", clicodigo],
      queryFn: async () => {
        const options = {
          method: "POST",
          body: JSON.stringify({ clicodigo }),
          headers: {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
          },
        }
        console.log("json enviado a la api", options.body)
        const response = await fetchwrapper("/AsociacionProdAgencia/getBodegasCliente", options)
        const result = await response.json()
        console.log("datos de la api", result)
        return result.data
      },
      enabled: !!clicodigo,
      onError: (error) => {
        console.log("Error fetching data", error)
      },
    })
  }
  useEffect(() => {
    // Solo actualiza bodegas si dataBodegas tiene valores
    if (dataBodegas.length > 0) {
      setBodegas(dataBodegas)
    }
  }, [dataBodegas])
  const {
    data: dataContactos = [],
    isError: dataContactosError,
    isFetching: isFetchingContactos,
    isLoading: isLoadingContactos,
    refetch: refetchGetAllContactos,
  } = useGetAllContactos(filtros.cliente.clicodigo)
  useEffect(() => {
    if (dataContactos.length > 0) {
      setBodegas(dataContactos)
    }
  }, [dataContactos])
  const handleContactoChange = (selectedValue) => {
    const [agenCod, agenDescri, contactoDescri] = selectedValue.split(",")
    setContacto(contactoDescri)
    setAgenciaDescripcion(agenDescri)
    setAgencia(agenCod)
    setAutoCompleteValueContacto(selectedValue)
  }
  useEffect(() => {
    setAgencia(agencia)
    setContacto(contacto)
    setAgenciaDescripcion(agenciaDescripcion)
    console.log("cod agencia", agencia)
    console.log("descri agencia", agenciaDescripcion)
    console.log("contacto descri", contacto)
  }, [contacto])
  function useGetAllContactos(clicodigo) {
    return useQuery({
      queryKey: ["contactoAsociacionProductosAgencias", clicodigo],
      queryFn: async () => {
        const codigoCliente = filtros.cliente.clicodigo
        console.log("codigo cliente", codigoCliente)
        const options = {
          method: "POST",
          body: JSON.stringify({ clicodigo }),
          headers: {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
          },
        }
        console.log("json enviado a la api", options.body)
        const response = await fetchwrapper("/AsociacionProdAgencia/getContactosCliente", options)
        const result = await response.json()
        console.log("datos de la api", result)
        return result.data
      },
      keepPreviousData: true,
      enabled: !!clicodigo,
      onError: (error) => {
        console.log("Error fetching data", error)
      },
    })
  }
  const { mutateAsync: createAsociacion, isPending: isCreatingAsociacion } = useCreateAsociacion()
  const navigate = useNavigate()
  function useCreateAsociacion() {
    const queryClient = useQueryClient()
    return useMutation({
      mutationFn: async (asociacion) => {
        // send api update request here
        // send api update request here
        const options = {
          method: "POST",
          body: JSON.stringify(asociacion),
          headers: {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
          },
        }
        console.log("json", options.body)
        let response = await fetchwrapper(`/AsociacionProdAgencia/crearAsociacion`, options)

        response = response.json()
        console.log(response)
        return response
      },

      // client side optimistic update
      onMutate: (newAsociacion) => {
        console.log(newAsociacion, "onmutate")
        queryClient.setQueryData(["Asociacion", newAsociacion.id], (prevAsociacion) => ({
          ...newAsociacion,
        }))
      },
    })
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    if (!validateForm()) {
      Swal.fire({
        icon: "error",
        title: "Campos Incompletos",
        text: "Por favor complete los campos EXT para todas las filas seleccionadas.",
      })
      return
    }

    try {
      const asociacion = {
        invcodigo: filtros.articulo.invcodigo,
        bodcodigo: bodega,
        artcodigo: filtros.articulo.artcodigo,
        embcodigo: filtros.embalaje.embcodigo,
        clicodigo: filtros.cliente.clicodigo,
        agecodigo: agencia,
        condescri: contacto,
      }
      console.log(asociacion)

      await createAsociacion(asociacion)
      await Swal.fire({
        icon: "success",
        title: "Operación exitosa",
        text: "Se guardaron los cambios",
      })
      navigate("/home/dashboard/AsociacionProdAgencias")
    } catch (error) {
      Swal.fire({
        title: "Error",
        text: "No se pudieron guardar los cambios",
        icon: "error",
        confirmButtonText: "OK",
      }).then(() => {
        navigate("/home/dashboard/AsociacionProdAgencias") // Navega de vuelta cuando se cierre el SweetAlert
      })
    }
  }
  return (
    <ThemeProvider theme={theme}>
      <Header />
      <div className="main main-app p-3 p-lg-4">
        <BackIcon />
        <div style={{ display: "flex", flexDirection: "row", gap: "10px" }}>
          {/* <div style={{ paddingTop: "10px", paddingBottom: "10px" }}>
            <CustomTooltip title={"Buscar"}>
              <Button style={{ fontSize: "0.9vw" }} onClick={() => navigate("/home/dashboard/PickingSugerido/buscar")}>
                <img src={BuscarIcon} alt="Crear" style={{ width: "40px" }} />
              </Button>
            </CustomTooltip>
          </div> */}
          <div style={{ display: "flex", alignItems: "center", gap: "16px", padding: "5px" }}>
            <CustomTooltip title={"Crear"}>
              <Button onClick={handleSubmit}>
                <img src={GrabarIcon} alt="Grabar" style={{ width: "40px" }} />
              </Button>
            </CustomTooltip>
          </div>
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            margin: "0 30px 30px 30px",
            fontSize: "25px",
          }}
        >
          <b>Asociacion de Productos a Agencias</b>
        </div>

        <Box className={StyledRoot}>
          <CustomBackdrop isLoading={isCreatingAsociacion} />
          <Container>
            <ClienteBox>
              <CustomHelperDetail
                label="Cliente"
                valueSearched={filtros.cliente?.clicodigo}
                endpoint="/AsociacionProdAgencia/getCliente"
                valueInputMain="clicodigo"
                valueInputSecondary="clinombre"
                idSearchField="clicodigo"
                errorMsgIdSearch="Error fetching data:"
                errorMsgFilterSearch="Error en cargar datos"
                queryKeyModal="clienteAsociacionProdAgencia"
                perPage={10}
                placeholder=""
                columnsTable={[
                  {
                    accessorKey: "ciacodigo",
                    header: "Ciacodigo",
                    size: 100,
                    Cell: ({ cell }) => {
                      const value = cell.getValue()
                      return <span>{value}</span>
                    },
                  },
                  {
                    accessorKey: "clicodigo",
                    header: "Código de Cliente",
                    size: 100,
                    Cell: ({ cell }) => {
                      const value = cell.getValue()
                      return <span>{value}</span>
                    },
                  },
                  {
                    accessorKey: "clinombre",
                    header: "Nombre del Cliente",
                    size: 250,
                    Cell: ({ cell }) => {
                      const value = cell.getValue()
                      return <span>{value}</span>
                    },
                  },
                  {
                    accessorKey: "cliruc",
                    header: "Número de identificación",
                    size: 150,
                    Cell: ({ cell }) => {
                      const value = cell.getValue()
                      return <span>{value}</span>
                    },
                  },
                  {
                    accessorKey: "clitelef1",
                    header: "Teléfono",
                    size: 100,
                    Cell: ({ cell }) => {
                      const value = cell.getValue()
                      return <span>{value}</span>
                    },
                  },
                  {
                    accessorKey: "clidirec",
                    header: "Dirección",
                    size: 400,
                    Cell: ({ cell }) => {
                      const value = cell.getValue()
                      return <p>{value}</p>
                    },
                  },
                  {
                    accessorKey: "clireferencia1",
                    header: "Referencia Rápida",
                    size: 120,
                    Cell: ({ cell }) => {
                      const value = cell.getValue()
                      return <p>{value}</p>
                    },
                  },
                  {
                    accessorKey: "zoncodigo",
                    header: "Zona",
                    size: 120,
                    Cell: ({ cell }) => {
                      const value = cell.getValue()
                      return <span>{value}</span>
                    },
                  },
                  {
                    accessorKey: "clistatus",
                    header: "Estado",
                    size: 120,
                    Cell: ({ cell }) => {
                      const value = cell.getValue()
                      if (value === "A") return "Activo"
                      if (value === "I") return "Inactivo"
                      return <span>{value}</span>
                    },
                  },
                ]}
                onHandleSelectedData={(v) => handleSetFiltros("cliente", v)}
                sxInputMain={{
                  minWidth: "170px",
                  maxWidth: "170px",
                  marginRight: "10px",
                }}
                sxInputSecondary={{
                  width: "100%",
                }}
              />
            </ClienteBox>
            <EmbalajeBox>
              <CustomHelperDetail
                label="Embalaje"
                valueSearched={filtros.embalaje?.embcodigo}
                endpoint="/AsociacionProdAgencia/getAllEmbalajes"
                valueInputMain="embcodigo"
                valueInputSecondary="embdescripcion"
                idSearchField="embcodigo"
                errorMsgIdSearch="Error fetching data:"
                errorMsgFilterSearch="Error en cargar datos"
                queryKeyModal="embalajeAsociacionProdAgencia"
                perPage={10}
                placeholder=""
                columnsTable={[
                  {
                    accessorKey: "ciacodigo",
                    header: "Ciacodigo",
                    size: 100,
                    Cell: ({ cell }) => {
                      const value = cell.getValue()
                      return <span>{value}</span>
                    },
                  },
                  {
                    accessorKey: "embcodigo",
                    header: "Código de Embalaje",
                    size: 100,
                    Cell: ({ cell }) => {
                      const value = cell.getValue()
                      return <span>{value}</span>
                    },
                  },
                  {
                    accessorKey: "embdescripcion",
                    header: "Descripcion",
                    size: 250,
                    Cell: ({ cell }) => {
                      const value = cell.getValue()
                      return <span>{value}</span>
                    },
                  },
                  {
                    accessorKey: "embmetros3",
                    header: "M3",
                    size: 150,
                    Cell: ({ cell }) => {
                      const value = cell.getValue()
                      return <span>{value}</span>
                    },
                  },
                  {
                    accessorKey: "embpieza",
                    header: "Pieza",
                    size: 100,
                    Cell: ({ cell }) => {
                      const value = cell.getValue()
                      return <span>{value}</span>
                    },
                  },

                  {
                    accessorKey: "embstatus",
                    header: "Estado",
                    size: 120,
                    Cell: ({ cell }) => {
                      const value = cell.getValue()
                      if (value === "A") return "Activo"
                      if (value === "I") return "Inactivo"
                      return <span>{value}</span>
                    },
                  },
                ]}
                onHandleSelectedData={(v) => handleSetFiltros("embalaje", v)}
                sxInputMain={{
                  minWidth: "170px",
                  maxWidth: "170px",
                  marginRight: "10px",
                }}
                sxInputSecondary={{
                  width: "100%",
                }}
              />
            </EmbalajeBox>
            <ArticuloBox>
              <CustomHelperDetail
                label="Articulo"
                valueSearched={filtros.articulo?.artcodigo}
                endpoint="/AsociacionProdAgencia/getAllProductos"
                valueInputMain="artcodigo"
                valueInputSecondary="artdescri"
                idSearchField="artcodigo"
                errorMsgIdSearch="Error fetching data:"
                errorMsgFilterSearch="Error en cargar datos"
                queryKeyModal="articuloAsociacionProdAgencia"
                perPage={10}
                placeholder=""
                columnsTable={[
                  {
                    accessorKey: "ciacodigo",
                    header: "Ciacodigo",
                    size: 100,
                    Cell: ({ cell }) => {
                      const value = cell.getValue()
                      return <span>{value}</span>
                    },
                  },
                  {
                    accessorKey: "artcodigo",
                    header: "Código de Articulo",
                    size: 100,
                    Cell: ({ cell }) => {
                      const value = cell.getValue()
                      return <span>{value}</span>
                    },
                  },
                  {
                    accessorKey: "artdescri",
                    header: "Descripcion",
                    size: 250,
                    Cell: ({ cell }) => {
                      const value = cell.getValue()
                      return <span>{value}</span>
                    },
                  },
                  {
                    accessorKey: "marcodigo",
                    header: "Codigo Marca",
                    size: 150,
                    Cell: ({ cell }) => {
                      const value = cell.getValue()
                      return <span>{value}</span>
                    },
                  },
                  {
                    accessorKey: "mardescri",
                    header: "Marca",
                    size: 100,
                    Cell: ({ cell }) => {
                      const value = cell.getValue()
                      return <span>{value}</span>
                    },
                  },
                  {
                    accessorKey: "medcodigo",
                    header: "Med Codigo",
                    size: 100,
                    Cell: ({ cell }) => {
                      const value = cell.getValue()
                      return <span>{value}</span>
                    },
                  },
                  {
                    accessorKey: "meddescri",
                    header: "Med descripcion",
                    size: 100,
                    Cell: ({ cell }) => {
                      const value = cell.getValue()
                      return <span>{value}</span>
                    },
                  },
                  {
                    accessorKey: "artcantactual",
                    header: "Cantidad",
                    size: 100,
                    Cell: ({ cell }) => {
                      const value = cell.getValue()
                      const intValue = Math.trunc(value)
                      return <span>{intValue}</span>
                    },
                  },
                  {
                    accessorKey: "artprecventa1",
                    header: "Lista de precios 1",
                    size: 100,
                    Cell: ({ cell }) => {
                      const value = cell.getValue()
                      const intValue = Math.trunc(value)
                      return <span>{intValue}</span>
                    },
                  },
                  {
                    accessorKey: "artprecventa2",
                    header: "Lista de precios 2",
                    size: 100,
                    Cell: ({ cell }) => {
                      const value = cell.getValue()
                      const intValue = Math.trunc(value)
                      return <span>{intValue}</span>
                    },
                  },
                  {
                    accessorKey: "artprecventa3",
                    header: "Lista de precios 3",
                    size: 100,
                    Cell: ({ cell }) => {
                      const value = cell.getValue()
                      const intValue = Math.trunc(value)
                      return <span>{intValue}</span>
                    },
                  },
                  {
                    accessorKey: "artprecventa4",
                    header: "Lista de precios 4",
                    size: 100,
                    Cell: ({ cell }) => {
                      const value = cell.getValue()
                      const intValue = Math.trunc(value)
                      return <span>{intValue}</span>
                    },
                  },
                  {
                    accessorKey: "artprecventa5",
                    header: "Lista de precios 5",
                    size: 100,
                    Cell: ({ cell }) => {
                      const value = cell.getValue()
                      const intValue = Math.trunc(value)
                      return <span>{intValue}</span>
                    },
                  },
                  {
                    accessorKey: "artprecventa6",
                    header: "Lista de precios 6",
                    size: 100,
                    Cell: ({ cell }) => {
                      const value = cell.getValue()
                      const intValue = Math.trunc(value)
                      return <span>{intValue}</span>
                    },
                  },
                  {
                    accessorKey: "lindescri",
                    header: "Linea",
                    size: 100,
                    Cell: ({ cell }) => {
                      const value = cell.getValue()
                      return <span>{value}</span>
                    },
                  },
                  {
                    accessorKey: "codigo2",
                    header: "Codigo 2",
                    size: 100,
                    Cell: ({ cell }) => {
                      const value = cell.getValue()
                      return <span>{value}</span>
                    },
                  },
                  {
                    accessorKey: "artstatus",
                    header: "Estado",
                    size: 120,
                    Cell: ({ cell }) => {
                      const value = cell.getValue()
                      if (value === "A") return "Activo"
                      if (value === "I") return "Inactivo"
                      return <span>{value}</span>
                    },
                  },
                ]}
                onHandleSelectedData={(v) => handleSetFiltros("articulo", v)}
                sxInputMain={{
                  minWidth: "170px",
                  maxWidth: "170px",
                  marginRight: "10px",
                }}
                sxInputSecondary={{
                  width: "100%",
                }}
              />
            </ArticuloBox>
            <BodegaBox>
              <InputLabel>Bodega</InputLabel>
              <CustomAutoComplete
                items={dataBodegas}
                onSelect={handleBodegaChange}
                placeholder={"Buscar Bodega"}
                value={autoCompleteValueBodega}
              />
            </BodegaBox>
            <ContactoBox>
              <InputLabel>Contacto</InputLabel>
              <CustomAutoComplete
                items={dataContactos}
                onSelect={handleContactoChange}
                placeholder={"Buscar Contacto"}
                value={autoCompleteValueContacto}
              />
            </ContactoBox>
          </Container>
        </Box>
      </div>
    </ThemeProvider>
  )
}
export default CrearAsociacionProdAgencias
